<template>
    <div class="">
        <div class="employee-attendance-wrapper">

             <div class="col-sm-2 company-form-box-title mb-3 pl-0">
                Attendance Log
            </div>
        <div class="clearfix row pb-2 mb-2 no-margin">
            <div class="col-sm-4 pl-0 leave-search-mobile">
                <div class="custom-search">
                    <b-input-group class="mb-0 attendance-search">
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
            </div>
            <div class="col-sm-8 attendance-button-wrapper mobile-btn-alignment">
                <div class="attendance-select-wrapper w-50">
                    <div class="row leave-year-month-mobile">
                        <div class="col-sm-5">
                            <b-input-group class="mb-2">
                                <b-input-group-prepend is-text>
                                    Year
                                </b-input-group-prepend>
                                <b-form-select id="year" name="year" v-model="year" :options="years" @change="reloadData()"></b-form-select>
                            </b-input-group>
                        </div>
                        <div class="col-sm-6">
                            <b-input-group class="mb-2">
                                <b-input-group-prepend is-text>
                                    Month
                                </b-input-group-prepend>
                                <b-form-select id="month" name="month" v-model="month" :options="months" @change="reloadData()"></b-form-select>
                            </b-input-group>
                        </div>

                    </div>
                </div>
                <a class="ml-1 cursor-pointer dowload-button mobile-left" :href="$api_url+'/front/employee/attendance/month?export_flg=1&month='+this.month+'&year='+this.year"><b-icon class="cursor-pointer" icon="cloud-download" font-scale="2" ></b-icon>
                </a>

            </div>

        </div>
        <div class="row py-2 mb-3">



            <div class="col-sm-10 attendance-button-wrapper">

            </div>
        </div>

        <b-modal id="bv-modal-import-attendance" scrollable  hide-footer title="Import Attendance">

            <b-overlay :show="showoverlay" rounded="sm" class="">

                <b-form-file id="datafile" name="datafile" @change="uploadFile"  accept=".xlsx,.xls"></b-form-file>
                <div v-if='errormsg'>
                    <div v-if="errormsg.length > 0" class="alert alert-danger my-3">Total error {{errormsg.length}}</div>
                    <ul class="list-group ">
                        <li class="list-group-item list-group-item-danger" v-for='error in errormsg'>{{error}}</li>
                    </ul>
                </div>
            </b-overlay>
        </b-modal>

        <div class="row justify-content-center no-margin">
            <div class="col-sm-12  px-0 table-parent">

            </div>
            <div class="col-sm-12  px-0 table-parent">
                <table class="table table-responsive attendance-table table-sticky border" style="table-layout:fixed;">
                    <thead class="table-head" style="">
                        <tr>
                            <td class="employee" > Employee</td>
                            <td class="" align="center" v-for="(day_details , n) in week_days_header" :key="n" :style="{ backgroundColor: head_color[day_details.day] }">
                                <div :title="day_details.title" v-b-tooltip>{{n}}</div>
                            </td>
                        </tr>
                    </thead>
                    <tbody class="table-body">
                        <tr v-for="(attendance , temp) in paginatedData" :key="attendance.id">
                            <td class="name" >{{ attendance.name }}</td>
                            <td v-for="(day_details , d) in week_days_header" :key="d" align="center">
                                <template v-if="month == this_month && this_year == year">
                                    <template v-if="(parseInt(d) <= parseInt(today_index))">

                                        <div :class="{ 'today' : parseInt(d) == parseInt(today_index)}">
                                            <template  v-if="day_details.day == 'weekend'" >
                                                <div class="text-info attendance-box" :style="{ backgroundColor: head_color[day_details.day] }"></div>
                                            </template>
                                            <template  v-else-if="day_details.day == 'holiday'">
                                                <div  class="text-success attendance-box" :style="{ backgroundColor: head_color[day_details.day] }"></div>
                                            </template>
                                            <template  v-else>

                                                <template v-if="attendance.attendances_list_by_day[d]">
                                                    <template v-if="attendance.attendances_list_by_day[d].id">
                                                        <div :id="'c'+attendance.attendances_list_by_day[d].id">
                                                            <!-- FIX 1: leave_data checked FIRST, before success/early/late status -->
                                                            <template v-if="attendance.attendances_list_by_day[d].leave_data">
                                                                <div class="cursor-pointer attendance-box leave" :style="{ background: attendance.attendances_list_by_day[d].leave_data.color }">
                                                                </div>
                                                                <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">
                                                                    {{ leave_titles[attendance.attendances_list_by_day[d].leave_data.leave_type_id] }} {{ attendance.attendances_list_by_day[d].leave_data.comment ?? '' }}
                                                                </b-tooltip>
                                                            </template>

                                                            <template v-else-if="((attendance.attendances_list_by_day[d].late_check_in <= grace_time_late_check_in) && (attendance.attendances_list_by_day[d].early_checkout <= grace_time_early_checkout) && (attendance.attendances_list_by_day[d].absent == 0) && (attendance.attendances_list_by_day[d].activity_log != ''))">
                                                                <div class="cursor-pointer attendance-box success" @click="showActivity(attendance.attendances_list_by_day[d])">

                                                                </div>
                                                                <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">
                                                                    {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment ?? ''}}
                                                                    <template v-if="attendance.attendances_list_by_day[d].auto_checkout == 1"> <br /> System Intervened</template>
                                                                </b-tooltip>

                                                            </template>

                                                            <template v-else-if="(attendance.attendances_list_by_day[d].early_checkout > 0)">
                                                                <div class="cursor-pointer attendance-box early_leave" @click="showActivity(attendance.attendances_list_by_day[d])">

                                                                </div>
                                                                <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">
                                                                    {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment ?? ''}}
                                                                    <template v-if="attendance.attendances_list_by_day[d].auto_checkout == 1"> <br /> System Intervened</template>
                                                                </b-tooltip>
                                                            </template>

                                                            <template v-else-if="(attendance.attendances_list_by_day[d].late_check_in > 0)">
                                                                <div class="cursor-pointer attendance-box late" @click="showActivity(attendance.attendances_list_by_day[d])">

                                                                </div>
                                                                <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">
                                                                    {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment ?? ''}}
                                                                    <template v-if="attendance.attendances_list_by_day[d].auto_checkout == 1"> <br /> System Intervened</template>
                                                                </b-tooltip>
                                                            </template>

                                                            <template v-else-if="attendance.attendances_list_by_day[d].absent == 1">
                                                                <!-- On Leave -->
                                                                <div class="cursor-pointer attendance-box absent">

                                                                </div>
                                                                <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover" v-if="attendance.attendances_list_by_day[d].comment != ''">
                                                                    {{attendance.attendances_list_by_day[d].comment ?? ''}}
                                                                    </b-tooltip>
                                                            </template>
                                                            <template v-else-if="(attendance.attendances_list_by_day[d].check_in == '00:00:00' || attendance.attendances_list_by_day[d].check_in == null) && (attendance.attendances_list_by_day[d].checkout == '00:00:00' || attendance.attendances_list_by_day[d].checkout == null) && attendance.attendances_list_by_day[d].absent != 1">

                                                                <!-- Employee absent but didnot apply for a leave -->
                                                                <div class="cursor-pointer attendance-box empty" @click="showResolve(attendance.employee_id , day_details.date)"><span class="cross-wrapper"></span></div>

                                                            </template>
                                                            <template v-else>

                                                                <!-- Employee absent but didnot apply for a leave -->
                                                                <div class="cursor-pointer attendance-box blank ">
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </template>

                                                    <!-- FIX 2: leave-only rows (no .id) now render their leave color instead of nothing -->
                                                    <template v-else-if="attendance.attendances_list_by_day[d].leave_data">
                                                        <div :id="'cd'+attendance.attendances_list_by_day[d].leave_data.id">
                                                            <div class="cursor-pointer attendance-box leave" :style="{ background: attendance.attendances_list_by_day[d].leave_data.color }"></div>
                                                            <b-tooltip :target="'cd'+attendance.attendances_list_by_day[d].leave_data.id" triggers="hover">
                                                                {{ leave_titles[attendance.attendances_list_by_day[d].leave_data.leave_type_id] }} {{ attendance.attendances_list_by_day[d].leave_data.comment ?? '' }}
                                                            </b-tooltip>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <div class="cursor-pointer attendance-box blank ">
                                                        </div>
                                                    </template>

                                                </template>
                                                <template v-else>
                                                    <!-- Employee absent but didnot apply for a leave -->
                                                    <div class="cursor-pointer attendance-box blank ">

                                                    </div>
                                                </template>
                                            </template>
                                        </div>
                                    </template>
                                    <!-- FIX 3: future days now show leave color before falling back to the dash -->
                                    <template v-else-if="attendance.attendances_list_by_day[d] && attendance.attendances_list_by_day[d].leave_data">
                                        <div :id="'fd'+attendance.attendances_list_by_day[d].leave_data.id">
                                            <div class="cursor-pointer attendance-box leave" :style="{ background: attendance.attendances_list_by_day[d].leave_data.color }"></div>
                                            <b-tooltip :target="'fd'+attendance.attendances_list_by_day[d].leave_data.id" triggers="hover">
                                                {{ leave_titles[attendance.attendances_list_by_day[d].leave_data.leave_type_id] }} {{ attendance.attendances_list_by_day[d].leave_data.comment ?? '' }}
                                            </b-tooltip>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <b-icon icon="dash" variant="info" font-scale="2"></b-icon>
                                    </template>
                                </template>

                                <template v-else>
                                    <template  v-if="day_details.day == 'weekend'" >
                                        <div class="text-info attendance-box" :style="{ backgroundColor: head_color[day_details.day] }"></div>
                                    </template>
                                    <template  v-else-if="day_details.day == 'holiday'">
                                        <div  class="text-success attendance-box" :style="{ backgroundColor: head_color[day_details.day] }"></div>
                                    </template>

                                    <template  v-else>

                                        <template v-if="attendance.attendances_list_by_day[d]">
                                            <template v-if="attendance.attendances_list_by_day[d].id">
                                                <div :id="'c'+attendance.attendances_list_by_day[d].id">
                                                    <!-- FIX 4: leave_data checked FIRST here too, mirroring FIX 1 -->
                                                    <template v-if="attendance.attendances_list_by_day[d].leave_data">
                                                        <div class="cursor-pointer attendance-box leave" :style="{ background: attendance.attendances_list_by_day[d].leave_data.color }">
                                                        </div>
                                                        <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">
                                                            {{ leave_titles[attendance.attendances_list_by_day[d].leave_data.leave_type_id] }} {{ attendance.attendances_list_by_day[d].leave_data.comment ?? '' }}
                                                        </b-tooltip>
                                                    </template>

                                                    <template v-else-if="((attendance.attendances_list_by_day[d].late_check_in <= grace_time_late_check_in) && (attendance.attendances_list_by_day[d].early_checkout <= grace_time_early_checkout) && (attendance.attendances_list_by_day[d].absent == 0) && (attendance.attendances_list_by_day[d].activity_log != ''))">
                                                        <div class="cursor-pointer attendance-box success" @click="showActivity(attendance.attendances_list_by_day[d])">

                                                        </div>
                                                        <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">
                                                            {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment ?? ''}}
                                                            <template v-if="attendance.attendances_list_by_day[d].auto_checkout == 1"> <br /> System Intervened</template>
                                                        </b-tooltip>

                                                    </template>

                                                    <template v-else-if="(attendance.attendances_list_by_day[d].early_checkout > 0)">
                                                        <div class="cursor-pointer attendance-box early_leave" @click="showActivity(attendance.attendances_list_by_day[d])">

                                                        </div>
                                                        <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">
                                                            {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment ?? ''}}
                                                            <template v-if="attendance.attendances_list_by_day[d].auto_checkout == 1"> <br /> System Intervened</template>
                                                        </b-tooltip>
                                                    </template>

                                                    <template v-else-if="(attendance.attendances_list_by_day[d].late_check_in > 0)">
                                                        <div class="cursor-pointer attendance-box late" @click="showActivity(attendance.attendances_list_by_day[d])">

                                                        </div>
                                                        <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">
                                                            {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment ?? ''}}
                                                            <template v-if="attendance.attendances_list_by_day[d].auto_checkout == 1"> <br /> System Intervened</template>
                                                        </b-tooltip>
                                                    </template>

                                                    <template v-else-if="attendance.attendances_list_by_day[d].absent == 1">
                                                        <!-- On Leave -->
                                                        <div class="cursor-pointer attendance-box absent">

                                                        </div>
                                                        <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover" v-if="attendance.attendances_list_by_day[d].comment != ''">
                                                            {{attendance.attendances_list_by_day[d].comment ?? ''}}
                                                            </b-tooltip>
                                                    </template>
                                                    <template v-else-if="(attendance.attendances_list_by_day[d].check_in == '00:00:00' || attendance.attendances_list_by_day[d].check_in == null) && (attendance.attendances_list_by_day[d].checkout == '00:00:00' || attendance.attendances_list_by_day[d].checkout == null) && attendance.attendances_list_by_day[d].absent != 1">

                                                        <!-- Employee absent but didnot apply for a leave -->
                                                        <div class="cursor-pointer attendance-box empty" @click="showResolve(attendance.employee_id , day_details.date)"><span class="cross-wrapper"></span></div>

                                                    </template>
                                                    <template v-else>

                                                        <!-- Employee absent but didnot apply for a leave -->
                                                        <div class="cursor-pointer attendance-box blank ">
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <template v-else-if="attendance.attendances_list_by_day[d].leave_data">
                                                <div :id="'cd'+attendance.attendances_list_by_day[d].leave_data.id">

                                                    <!-- On Leave -->
                                                    <div class="cursor-pointer attendance-box leave" :style="{ background: attendance.attendances_list_by_day[d].leave_data.color }">

                                                    </div>
                                                    <b-tooltip :target="'cd'+attendance.attendances_list_by_day[d].leave_data.id" triggers="hover">
                                                        {{leave_titles[attendance.attendances_list_by_day[d].leave_data.leave_type_id] + ' ' + attendance.attendances_list_by_day[d].leave_data.comment ?? ''}}
                                                    </b-tooltip>

                                                </div>
                                            </template>
                                            <template v-else>
                                                <div>
                                                    <!-- Employee absent but didnot apply for a leave -->
                                                    <div class="cursor-pointer attendance-box blank ">
                                                    </div>
                                                </div>
                                            </template>


                                        </template>
                                        <template v-else>
                                            <!-- Employee absent but didnot apply for a leave -->
                                            <div class="cursor-pointer attendance-box blank ">

                                            </div>
                                        </template>
                                    </template>
                                </template>

                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">{{blankmsg}}</div>
                <div v-else class="px-3">
                    <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                        <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                            <ul class="pagination b-pagination float-left mb-0 mt-1">
                                <li class="page-item disabled m-2">View</li>
                                <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                            </ul>
                            <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-sm-12  px-0 legend-wrapper">
                <div class="attendance-log">
                    <div class="stats-info-wrapper legend mt-3">
                        <div class="row col-sm-12 trz_borders px-4 mb-0">
                            <div class="col-sm-3 py-3"><div class="mark current"></div><div class="text">Current</div></div>
                            <div class="col-sm-3 py-3"><div class="mark absent"></div><div class="text">Absent</div></div>
                            <div class="col-sm-3 py-3"><div class="mark present"></div><div class="text">Present</div></div>
                            <div class="col-sm-3 py-3"><div class="mark" :style="{ backgroundColor: holiday_color_code }"></div><div class="text">Holiday</div></div>
                            <div class="col-sm-3 py-3"><div class="mark":style="{ backgroundColor: weekend_color_code }"></div><div class="text">Weekend</div></div>
                            <div class="col-sm-3 py-3"><div class="mark late"></div><div class="text">Late</div></div>
                            <div class="col-sm-3 py-3"><div class="mark late"></div><div class="text">Left Early</div></div>
                            <template v-for="leavetype in leavetypes">
                                <div class="col-sm-3 py-3" >
                                    <div class="mark" :style="'background:'+leavetype.color_code"></div><div class="text">{{leavetype.title}}</div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <b-modal id="activity_logModal" size="xl" scrollable  hide-footer title="Attendence Info">
            <div class="row no-margin">
                <div class="col-md-6">
                    <div class="card punch-status">
                        <div class="card-body">
                            <h5 class="card-title">Timesheet <small class="text-muted">{{attendances_date}}</small></h5>
                            <div class="punch-det">
                                <h6>Punch In at</h6>
                                <p>{{check_in}}</p>
                            </div>
                            <div class="punch-info">
                                <div class="punch-hours">
                                    <span>{{work_time}} hrs</span>
                                </div>
                            </div>
                            <div class="punch-det">
                                <h6>Punch Out at</h6>
                                <p>{{checkout}}</p>
                            </div>
                            <div class="statistics">
                                <div class="row">
                                    <div class="col-md-6 col-6 text-center">
                                        <div class="stats-box">
                                            <p>Break</p>
                                            <h6>{{break_time}} hrs</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card recent-activity">
                        <div class="card-body">
                            <h5 class="card-title">Activity</h5>
                            <ul class="res-activity-list" v-if="activity_log">
                                <li v-for="(activity, index) in activity_log.split(',')">
                                    <p class="mb-0" v-if="index % 2 == 0">Punch In at</p>
                                    <p class="mb-0" v-else>Punch Out at</p>
                                    <p class="res-activity-time">
                                        <i class="far fa-clock"></i>
                                        {{formateMe(activity) }}
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal id="edit_Modal" size="l" scrollable  hide-footer title="Attendence Info">
            <div class="card border-0 no-shadow">
                <div class="card-body pt-0">
                    <h5 class="card-title">Timesheet <small class="text-muted">{{edit_date}}</small></h5>
                </div>
            </div>
            <div class="row no-margin">
                <div class="col-md-4 pr-2">
                    <div class="btn btn-primary cursor-pointer w-100" @click="addLeave()">Add Leave</div>
                </div>
                <div class="col-md-4 pl-2">
                    <div class="btn btn-primary cursor-pointer w-100" @click="workedOffsite(0)">Worked Offsite</div>
                </div>
                <div class="col-md-4 pl-2">
                    <div class="btn btn-primary cursor-pointer w-100" @click="workedOffsite(1)">Resolve</div>
                </div>
            </div>
        </b-modal>
        <b-modal id="addLeave_Modal" size="xl" scrollable  hide-footer title="Leave Details">
            <employee-leave-details v-if="this.employee_id > 0"  :attendances_date="this.edit_date" v-on:childToParent="reloadData"></employee-leave-details>
        </b-modal>
        <b-modal id="workedOffsite_Modal" size="xl" scrollable  hide-footer :title="'Resolve : ' + edit_date">
            <worked-offsite v-if="this.employee_id > 0"   :attendances_date="this.edit_date" :resolve_flg="resolve_flg" v-on:childToParent="reloadData"></worked-offsite>
        </b-modal>
    </div>
    </div>
</template>
<script>
    import moment from 'moment'
    export default{

        mounted() {
            if(this.check_ce == 1)
            {
                if(this.ce_flg == 1)
                    this.ce = true;
                else
                    this.ce = false;


            }
        },
        props: [ 'flg' , 'moment'],
        components: { },
        data(){
            const now = new Date();
            return {

                flag : this.flg,
                empfile : null,
                has_file : false,
                upload_url : '',
                process_url : '',

                attendances:[],
                week_days_header:[],
                head_color : {weekend : '#aaaaaa' , holiday : '#aaaaaa'},
                search:'',
                length: 50,
                temp_length: 50,
                length_options: [],
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                ce : true,
                today_index : 0,
                grace_time_late_check_in : 0,
                grace_time_early_checkout : 0,

                blankmsg : 'Fetching data..',

                can_download_template : true,


                attendances_date : null,

                check_in : null,
                checkout : null,
                work_time : 0,
                break_time : 0,
                over_time : 0,
                activity_log : null,

                edit_date : null,
                employee_id : 0,
                showoverlay:false,

                resolve_flg : 0,

                this_month: now.getMonth() + 1,
                month: now.getMonth() + 1,
                year: now.getFullYear(),
                this_year:now.getFullYear(),
                f_y:'',
                errormsg:[],
                leavetypes:[],
                months: [
                    { text: 'January', value: '1' },
                    { text: 'February', value: '2' },
                    { text: 'March', value: '3' },
                    { text: 'April', value: '4' },
                    { text: 'May', value: '5' },
                    { text: 'June', value: '6' },
                    { text: 'July', value: '7' },
                    { text: 'August', value: '8' },
                    { text: 'September', value: '9' },
                    { text: 'October', value: '10' },
                    { text: 'November', value: '11' },
                    { text: 'December', value: '12' }
                ],

                years: [
                    { text: '2021', value: '2021' },
                    { text: '2022', value: '2022' },
                    { text: '2023', value: '2023' },
                    { text: '2024', value: '2024' },
                    { text: '2025', value: '2025' },
                    { text: '2026', value: '2026' },
                ],
                weekend_color_code:'',
                holiday_color_code:'',
                show_lg:0,
                leave_color:[],
                leave_titles:[],


            }

        },
        methods:{

            setUrls:function()
            {
                this.upload_url = this.$api_url+"/employee/attendance/import";
                this.process_url = this.$api_url+'/front/employee/attendance/import/process';

            },

            uploadFile:function(event)
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                this.errormsg = [];
                this.empfile = event.target.files[0];

                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('empfile', this.empfile);

                axios.post(this.upload_url, data , config).
                    then(function (response){

                        this.has_file = true;

                        this.$bvToast.toast('Processing the data feed file.', {
                                            title: `Job on progress`,
                                            variant: 'info',
                                            solid: true
                                        });

                        this.showoverlay = false;
                        this.processFileData();

                    }.bind(this)).
                    catch(function (error)
                            {
                            });
            },
            processFileData:function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;
                this.errormsg = [];
                axios.get(this.process_url)
                .then(function (response) {

                        if(response.data.status)
                        {
                            this.$bvToast.toast('Valid attendance inputs have been successfully imported and invalid inputs have been ignored.', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                        this.$bvModal.hide('bv-modal-import-leave');

                            this.reloadData();
                            this.$bvModal.hide('bv-modal-import-attendance');
                        }
                        else
                        {
                            this.errormsg = response.data.errors;
                        }

                    this.showoverlay = false;

                }.bind(this)).catch(function (error){

                    currentObj.showoverlay = false;
                    currentObj.$bvToast.toast('Please correct the data and try again.', {
                                            title: `Data Template Error`,
                                            variant: 'danger',
                                            solid: true
                                        });

                }); ;
            },

            importAttendances: function()
            {
                this.$bvModal.show('bv-modal-import-attendance');
            },


            reloadData: function()
            {
                this.resolve_flg = 0;
                this.$bvModal.hide('edit_Modal');
                this.$bvModal.hide('addLeave_Modal');
                this.$bvModal.hide('workedOffsite_Modal');


                this.getEmployeesAttendanceNew();
            },
            resetdata : function()
            {
                this.attendances_date = null;
                this.check_in = null;
                this.checkout = null;
                this.work_time = 0;
                this.break_time = 0;
                this.over_time = 0;
            },
            convertMinsToHrsMins: function (minutes) {

                var h = Math.floor(minutes / 60);
                var m = minutes % 60;
                h = h < 10 ? '0' + h : h;
                m = m < 10 ? '0' + m : m;
                return h + ':' + m;
            },
            formateMe :function(minutes){

                if(minutes == '00:00:00' || minutes == null || minutes == '0') return '..';

                return moment(minutes, "hh:mm").format('LT');
            },
            showActivity : function(ins)
            {
                this.resetdata();

                this.attendances_date = moment(String(ins.attendances_date)).format('YYYY-MM-DD ');
                this.check_in = moment(ins.check_in, "hh:mm").format('LT');

                if(ins.checkout != '00:00:00' && ins.checkout != null)
                    this.checkout = moment(ins.checkout, "hh:mm").format('LT');
                else
                    this.checkout = '..';

                this.work_time = this.convertMinsToHrsMins(ins.work_time);
                this.break_time = this.convertMinsToHrsMins(ins.break_time);
                this.over_time = this.convertMinsToHrsMins(ins.over_time);

                this.activity_log = ins.activity_log;

                this.$bvModal.show('activity_logModal');

            },
            showResolve : function(employee_id , d)
            {
                return 0;
                this.resetdata();
                this.setEmployee(employee_id);
                this.edit_date = moment(String(d)).format('YYYY-MM-DD');
                this.employee_id = employee_id;
                this.$bvModal.show('edit_Modal');
            },
            addLeave : function()
            {
                this.$bvModal.hide('edit_Modal');
                this.$bvModal.show('addLeave_Modal');


            },
            workedOffsite : function(x)
            {
                this.resolve_flg = x;
                this.$bvModal.hide('edit_Modal');
                this.$bvModal.show('workedOffsite_Modal');
            },
            resolve : function()
            {

            },
            setEmployee(x)
            {
                let currentObj = this;
                let formData = new FormData();
                formData.append('employee_id', x);
                axios.post(this.$api_url+'/front/employee/setemployee', formData)
                    .then(function (response)
                    {
                       return;

                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },

            getEmployeesAttendanceNew: function()
            {

                if(!this.checkNet()) return false;
                this.getLeaveTypes();
                let currentObj = this;

                var today = new Date();

                let month = this.month;
                let year = this.year;

                axios.get(this.$api_url+'/front/employee/attendance/month' , {
                    params: {
                        month: month,
                        year: year,
                        export_flg : 0,
                    }
                }).then(function(response){
                    this.attendances = response.data.attendances_list;

                    if(this.attendances.length == 0)
                        this.blankmsg = "Looks like you have not added any employee attendance yet for the selected month.";


                    this.week_days_header = response.data.week_days_header;
                    this.head_color = response.data.head_color;

                    this.length_options = [{ value: 10, text: "10" },{ value: 20, text: "20" },
                                                    { value: 50, text: "50" },
                                                    { value: 100, text: "100" },
                                                    { value: 200, text: "200" },
                                                    { value: 500, text: "500" },
                                                    { value: this.attendances.length, text: "All" }
                                                ];
                    this.people = this.attendances.length;

                    this.today_index = response.data.today_index;

                    this.grace_time_late_check_in = response.data.grace_time_late_check_in;
                    this.grace_time_early_checkout = response.data.grace_time_early_checkout;



                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },

            getEmployeesAttendance: function()
            {

                if(!this.checkNet()) return false;
                this.getLeaveTypes();
                let currentObj = this;

                var today = new Date();

                let month = this.month;
                let year = this.year;
                let fiscal_year = this.getCurrentFinancialYear();
                this.f_y = this.getCurrentFinancialYear();
                let years = fiscal_year.split('-');

                if (month <= 6) year = years[1];
                else year = years[0];

                this.year = year;

                axios.get(this.$api_url+'/front/employee/attendance/month' , {
                    params: {
                        month: month,
                        year: year,
                        export_flg : 0,
                    }
                }).then(function(response){
                    this.attendances = response.data.attendances_list;

                    if(this.attendances.length == 0)
                        this.blankmsg = "Looks like you have not added any employee attendance yet for the selected month.";


                    this.week_days_header = response.data.week_days_header;
                    this.head_color = response.data.head_color;

                    this.length_options = [{ value: 10, text: "10" },{ value: 20, text: "20" },
                                                    { value: 50, text: "50" },
                                                    { value: 100, text: "100" },
                                                    { value: 200, text: "200" },
                                                    { value: 500, text: "500" },
                                                    { value: this.attendances.length, text: "All" }
                                                ];
                    this.people = this.attendances.length;

                    this.today_index = response.data.today_index;

                    this.grace_time_late_check_in = response.data.grace_time_late_check_in;
                    this.grace_time_early_checkout = response.data.grace_time_early_checkout;



                    let currentObj = this;


                    let st_date = new Date(year , month-2 , 1);
                    let en_date = new Date(year , month , 0);

                    this.start_date = moment(String(st_date)).format('Do MMMM YYYY');
                    this.end_date = moment(String(en_date)).format('Do MMMM YYYY');


                    axios.get(this.$api_url+'/front/employee/attendances/details' , {
                        params: {
                            st_date: this.start_date,
                            en_date: this.end_date,
                        }
                    }).then(function(response){


                        this.weekend_color_code = response.data.report.weekend_color_code;
                        this.holiday_color_code = response.data.report.holiday_color_code;
                        currentObj.show_lg = 1;


                    }.bind(this)).catch(function (error){ currentObj.serverError(error);});


                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
            setFirstPage :  function()
            {
                this.pagination.currentPage = 1;
                this.length = this.temp_length;
            },

            downloadData : function()
            {
                if(this.attendances.length > 0)
                {
                    if(!this.checkNet()) return false;
                    let currentObj = this;
                    axios.get(this.$api_url+'/front/employee/attendance/month' , {
                        params: {
                            month: this.month,
                            year: this.year,
                            export_flg : 1,
                        }
                    }).then(function(response){

                        if(response.data.attendances_list == 0)
                            this.blankmsg = "Looks like you have not added any employee attendance yet.";

                    }.bind(this)).catch(function (error){ currentObj.serverError(error);});
                }
            },
            getLeaveTypes: function()
            {
                if(!this.checkNet()) return false;

                axios.get(this.$api_url+'/front/leave/types?f=1' , {
                    params: {

                    }
                }).then(function(response){

                    this.leavetypes = response.data;
                    this.leavetypes.forEach(obj => {
                        this.leave_color[obj.id] = obj.color_code;
                        this.leave_titles[obj.id] = obj.title;

                    });

                }.bind(this));
            },


        },
        created: function(){

            this.getEmployeesAttendance();
            this.setUrls();


        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.attendances;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },


        }
    }
</script>
<style scoped>

.table-sticky{
    position: relative;
}
.table-sticky thead td {

    position: sticky;
    top: 0;
    background: #CCF4FE;
    z-index: 9;
}
.table-parent{
    height: 100vh;
    overflow: auto;

}
.custom-search .attendance-search {
	border: 1px solid #efefef;
	border-radius: 7px;
}
</style>